module.exports = __webpack_public_path__ + "img/straight_line2_icon.93a3e570.svg";